const MailConfig = () => import('Views/systemConfig/mail-config');

export default[
  { path: '/mail-config', component: MailConfig },
];



// WEBPACK FOOTER //
// ./src/router/systemConfig.js